export const REFUND_ASSIST_TOGGLE_SOURCE = {
  FTU_WIZARD: 'ftu_wizard',
  SETTINGS: 'settings',
} as const;
